<template>
  <div id="basic_info" class="wrapper">
    <!-- <gb /> -->
    <div id="basic_info_win" ref="basic_info">
      <button id="off_basic_info_win" @click="goTo('/main')">
        <img src="@/assets/images/icon/off.svg" alt="icon" />
      </button>
      <h2>Basic Information</h2>
      <label> Basic Information </label>
      <form>
        <div class="input">
          <span class="label"> Account </span>
          <input type="text" v-model="ac" disabled />
        </div>
        <div class="input">
          <span class="label"> School </span>
          <input type="text" v-model="sc" disabled />
        </div>
        <div class="input">
          <span class="label"> Name </span>
          <input type="text" v-model="name" />
        </div>
      </form>

      <label class="red"> Account Overview </label>
      <div class="text">
        <!-- <p>{{series_name}}</p>
        <p>E-Books　{{ebooks}}</p>
        <p>Resources　{{resources}}</p>
        <p>Multimedia　{{multi_media}}</p>
        <p>Public Resources　{{vpublic}}</p> -->

        <div v-for="(item,index) in overview" :key="index">
          <h5>{{item.series_name}}</h5>
          <ul>
            <li>
              <h6>Books</h6><p v-if="item.ebooks =='premium'">{{item.ebooks}}</p>
            </li>
            <li>
              <h6>Resources</h6><p v-if="item.resources =='premium'">{{item.resources}}</p>
            </li>
            <li>
              <h6>Multimedia</h6><p v-if="item.multi_media =='premium'">{{item.multi_media}}</p>
            </li>
            <li>
              <h6>Public Resources</h6><p v-if="item.public =='premium'">{{item.public}}</p>
            </li>
          </ul>
        </div>

        <!-- <h5>{{series_name}}</h5>
        <ul>
          <li>
            <h6>Books</h6><p v-if="ebooks =='ebooks'">{{ebooks}}</p>
          </li>
          <li>
            <h6>Resources</h6><p v-if="resources =='premium'">{{resources}}</p>
          </li>
          <li>
            <h6>Multimedia</h6><p v-if="multi_media =='premium'">{{multi_media}}</p>
          </li>
          <li>
            <h6>Public Resources</h6><p v-if="vpublic =='premium'">{{vpublic}}</p>
          </li>
        </ul> -->

      </div>
      <div class="btn">
        <button v-if="name_change" type="submit" @click="name_change_push()">
          ENTER
        </button>

        <button
          v-else
          style="filter: grayscale(1); cursor: no-drop"
          type="submit"
        >
          ENTER
        </button>
      </div>
    </div>

  </div>
</template>

<script setup>
import { token_expired } from "@/assets/js/token_expired";
// import gb from "@/components/bg.vue";
import axios from "axios";
import Swal from "sweetalert2";
import { ref, onMounted, watch } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";

const store = useStore();
const router = useRouter();

const ac = ref(null);
const sc = ref(null);
const name = ref(null);
const name_change = ref(false);

const basic_info = ref(null);

const overview = ref([]);
const series_name = ref(null);
const ebooks = ref(null);
const resources = ref(null);
const multi_media = ref(null);
const vpublic = ref(null);

const adjustZoom = (view) => {
  const baseWidth = 1920;
  const baseHeight = 1080;

  const windowWidth = window.innerWidth;
  const windowHeight = window.innerHeight;

  const scaleWidth = windowWidth / baseWidth;
  const scaleHeight = windowHeight / baseHeight;

  const scale = Math.min(scaleWidth, scaleHeight);

  if (view) {
    view.style.transform = `scale(${scale}) translate(-50%,-50%)`;
  }
};

function goTo(data) {
  router.push(`${data}`);
}

function get_info() {
  const FormData = require("form-data");
  let data = new FormData();
  data.append("tch_account", localStorage.getItem("ac"));

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/teacher-info/get`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {

      if (response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if(response.status == 520){
        get_info();
      }

      token_expired(response, router);
      console.log(response.data.data);

      console.log(response.data.data.series_permissions);

      overview.value = response.data.data.series_permissions;

      ac.value = response.data.data.tch_account;
      sc.value = response.data.data.school_name;
      name.value = response.data.data.tch_name;

      let originalName = name.value;

      watch(
        () => name.value,
        (newValue) => {
          if (newValue !== originalName) {
            name_change.value = true;
          }
        }
      );
      
    })
    .catch((error) => {
      console.log(error.response.data.code);

      if (error.response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (error.response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }
      
      if(error.status == 520){
        get_info();
      }
      token_expired(error, router);
      console.log(error);
    });
}

function name_change_push() {
  const FormData = require("form-data");
  let data = new FormData();
  data.append("tch_name", name.value);

  let config = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${store.state.path}api/db/teacher-info/patch`,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
    },
    data: data,
  };

  axios
    .request(config)
    .then((response) => {

      if (response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }
      
      if(response.status == 520){
        name_change_push();
      }

      console.log(response.data);

      Swal.fire({
        title: "Information",
        text: "Your data has been changed.",
        icon: "success",
        confirmButtonText: "OK",
        allowOutsideClick: false, // 禁止點擊背景關閉
        allowEscapeKey: false, // 禁止按Esc鍵關閉
        showCloseButton: false, // 不顯示右上角的關閉按鈕
      }).then((result) => {
        if (result.isConfirmed) {
          goTo("/main");
        }
      });
    })
    .catch((error) => {
      console.log(error.response.data.code);

      if (error.response.data.code == -2) {
        // 帳號沒有權限
        Swal.fire({
          title: "Error",
          text: "This account is not enabled.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }

      if (error.response.data.code == -3) {
        // 帳號到期
        Swal.fire({
          title: "Error",
          text: "This account has expired.",
          icon: "error",
          confirmButtonText: "Close",
        });
        router.push("/");
        return;
      }
      

      if(error.status == 520){
        name_change_push();
      }
      console.log(error);
    });
}

onMounted(() => {
  get_info();
  adjustZoom(basic_info.value);
});
</script>
